import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class EventService {
  keyDown: Subject<string> = new Subject<string>()

  constructor(private router: Router) {
    // do nothing
  }

  addEvent(event: string): void {
    switch (event) {
      case 'EXIT':
        this.router.navigate(['/'], { queryParamsHandling: 'preserve' })
        break
      default:
        this.keyDown.next(event)
        break
    }
  }
}
